// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LcFV","right":"styles_right__27aQF"};